import { render, staticRenderFns } from "./course-progress.vue?vue&type=template&id=0cf3bc18&"
import script from "./course-progress.vue?vue&type=script&lang=js&"
export * from "./course-progress.vue?vue&type=script&lang=js&"
import style0 from "./course-progress.vue?vue&type=style&index=0&id=0cf3bc18&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports